import select from 'dom-select';
import { cl, getCookie, getScrollbarWidth, LazyVideos, setScrollBarVar } from '@/utils';
import { bus } from '@/bus';
import AuthModal from '@/components/AuthModal';

function sameLinkClick(parent?: HTMLElement) {
  select.all<HTMLAnchorElement>('a', parent).forEach((link) => {
    if (link.origin === window.location.origin) {
      link.addEventListener('click', (ev) => {
        if (link.href === window.location.href) {
          ev.preventDefault();
          ev.stopPropagation();
          bus.emit('cancel');
        }
      });
    }
  });
}
function setActiveLinks(parent?: HTMLElement) {
  const pageSegments = new URL(window.location.href).pathname.split('/').filter((f) => !!f);
  const links = select.all<HTMLAnchorElement>('.active-links a', parent)

  links.forEach((link) => {
    if (link.origin === window.location.origin) {
      const linkSegments = new URL(link.href).pathname.split('/').filter((f) => !!f);
      const exact = link.getAttribute('data-exact') === '';

      if (
        exact && window.location.pathname === link.pathname
        || !exact && window.location.pathname.startsWith(link.pathname)
      ) {
        cl(link).add('active');
      } else {
        cl(link).remove('active');
      }
    }
  });
}

function setLocaleLinks() {
  select.all<HTMLAnchorElement>('[data-locale]').forEach((link) => {
    const original = link.getAttribute('data-locale');
    const pathname = window.location.pathname.replace(/^\/(es)?/g, '');
    link.href = original+(pathname.indexOf('/') === 0 ? pathname : '/'+pathname);
  });
}

function dialogs(parent?: HTMLElement) {
  select.all<HTMLDialogElement>('[data-dialog]').forEach((dialogTrigger) => {
    dialogTrigger.addEventListener('click', () => {
      const dialog = select<HTMLDialogElement>('dialog#'+dialogTrigger.getAttribute('data-dialog'));
      if (dialog) {
        dialog.showModal();
      }
    });
  });
}

function openAuthModal(authType) {
  const authModal = select<AuthModal>('b-auth-modal');

  if (authModal) {
    authModal.currentState = authType || 'login';
    authModal.setAttribute('type', authModal.currentState);
    authModal.hasAttribute('open') ? authModal.close() : authModal.open();
  }
}

function updateModalToggles(parent) {
  const toggleButtons = Array.from(parent.querySelectorAll('[data-el="auth-toggle"], [href*="#sign-up"], [href*="#login"]'));

  if (['#sign-up', '#login'].includes(window.location.hash)) {
    openAuthModal(window.location.hash.replace('#', ''));
  }

  toggleButtons.forEach((btn: HTMLButtonElement) => {
    btn.addEventListener('click', (ev) => {
      ev.preventDefault();
      // @ts-ignore
      openAuthModal(btn.href?.split('#')?.[1] || btn.dataset.authType);
    });
  })
}

export function globalInit() {
  sameLinkClick();
  setActiveLinks();
  setScrollBarVar();
  setLocaleLinks();
  dialogs();
  updateModalToggles(document);

  let scrollingDown = false;
  let scrollLength:number;
  let lastScrollTop:number;

  const lazyVideos = new LazyVideos();

  document.body.style.setProperty('--scroll-gap', `${getScrollbarWidth()}px`);

  bus.on('barba_enter', ({ next }) => {
    setActiveLinks();
    setLocaleLinks();
    dialogs(next.container);
    updateModalToggles(next.container);
    lazyVideos.update(next.container);
  })

  bus.on('afterSwap', (ev) => {
    requestAnimationFrame(() => {
      setActiveLinks(ev.target as HTMLElement);
      updateModalToggles(ev.target as HTMLElement);
    })
  })


  // bus.on('scroll', () => {
  //   let st = window.pageYOffset || document.documentElement.scrollTop;
  //
  //   if (st > lastScrollTop) {
  //     scrollingDown = true;
  //     scrollLength = 0;
  //     cl(document.body).add('scrolling-down').remove('scrolling-up');
  //   } else if (st < lastScrollTop) {
  //     scrollingDown = false;
  //     scrollLength++;
  //
  //     cl(document.body).remove('scrolling-down');
  //     if (scrollLength > 8) {
  //       cl(document.body).add('scrolling-up');
  //     }
  //   }
  //
  //   if (st >= (document.body.scrollHeight - document.body.clientHeight - 200)) {
  //     cl(document.body).add('close-to-end');
  //
  //   } else {
  //     cl(document.body).remove('close-to-end');
  //   }
  //
  //   lastScrollTop = st <= 0 ? 0 : st;
  //
  //   if (lastScrollTop > 200) {
  //     cl(document.body).add('scrolled-bit');
  //   } else {
  //     cl(document.body).remove('scrolled-bit');
  //   }
  //
  //   if (lastScrollTop > 600) {
  //     cl(document.body).add('scrolled');
  //   } else {
  //     cl(document.body).remove('scrolled');
  //   }
  // });
}
